import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AutomationService } from '../automation.service';
import { STATUS_CODES, USER_TYPES } from '../../common/constants/defines';
import { Router } from '@angular/router';
import { intersection } from 'lodash';


@Component({
    selector: 'tdrs-creation',
    templateUrl: './tdrs-creation.component.html',
    styleUrls: ['./tdrs-creation.component.css']
})
export class TDRSCreationComponent implements OnDestroy {

    public automationData = null;

    public defaultStubsPerRecord = {};

    public allRecords: string[] = [];

    public statusCodes = STATUS_CODES;

    public errorOverLay = null;

    public oldValuesForStubs = {};

    public automationProccesId: string = null;

    public defaultStubsStatus = null;

    public allStubsAreDetected: boolean = true;

    constructor(private automationService: AutomationService, private router: Router) {
    }

    ngOnDestroy(): void {

        this.automationService.registerSpinner.next(false);
    }

    startAutomationProccess(data) {

        this.allRecords = [];

        this.automationService.registerSpinner.next(true);

        if (data.validateSheet) {

            this.automationService.validateTdrsSheet(data.file)
                .subscribe((identifiersPerService) => {

                    this.automationService.registerSpinner.next(false);

                    if (identifiersPerService && identifiersPerService.length) {

                        this.automationService.identifiersPerService = identifiersPerService;

                        this.errorOverLay = {
                            message: `Your sheet has same Identifier values with the already exist stubs,
                         you will be redirected to the tdrs validation page`,
                            success: false
                        };
                    } else {

                        this.generateAutomationProccess(data);
                    }
                }, (error) => {

                    this.automationService.registerSpinner.next(false);

                    if (error && error.json) {

                        this.errorOverLay = {
                            message: error.json().message,
                            success: false
                        };
                    } else {

                        this.errorOverLay = {
                            message: error,
                            success: false
                        };
                    }
                });
        } else {

            this.generateAutomationProccess(data);
        }
    }

    generateAutomationProccess(data) {

        this.automationService.registerSpinner.next(true);

        this.automationService.generateAutomationProccess(data.file)
            .subscribe((automationData) => {

                this.oldValuesForStubs = automationData.oldValuesForStubs;

                this.defaultStubsPerRecord = automationData.defaultStubsPerRecord;

                this.allRecords = automationData.allRecords;

                for (let recordName of this.allRecords) {

                    recordName = recordName.toLowerCase();

                    for (let counter = 0; counter < this.defaultStubsPerRecord[recordName].length; counter++) {

                        this.defaultStubsPerRecord[recordName][counter].originalStubName = this.defaultStubsPerRecord[recordName][counter].stubName;
                    }
                }

                this.automationProccesId = automationData.automationProccesId;

                this.defaultStubsStatus = automationData.defaultStubsStatus;

                this.automationService.fileData = data.fileNameDetails;

                this.automationService.registerSpinner.next(false);

                setTimeout(() => {

                    const elmnt = document.getElementById("recordsOverview");

                    elmnt.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }, (error) => {

                this.automationService.registerSpinner.next(false);

                    if (error && error.json) {

                        this.errorOverLay = {
                            message: error.json().message,
                            success: false
                        };
                    } else {

                        this.errorOverLay = {
                            message: error,
                            success: false
                        };
                    }
            });
    }

    generateTDRS() {

        this.automationService.registerSpinner.next(true);

        this.automationService.generateTDRS({
            defaultStubsStatus: this.defaultStubsStatus,
            automationProccesId: this.automationProccesId,
            defaultStubsPerRecord: this.defaultStubsPerRecord
        }).subscribe((data) => {

            this.automationService.registerSpinner.next(false);

            this.router.navigate(['/automation/automation-proccesses-list']);
        }, (error) => {
            this.automationService.registerSpinner.next(false);

                if (error && error.json) {

                    this.errorOverLay = {
                        message: error.json().message,
                        success: false
                    };
                } else {

                    this.errorOverLay = {
                        message: error,
                        success: false
                    };
                }
        });
    }

    update(recordName, dataPerRecord, allOccurrence) {

        this.automationService.getStubByName(dataPerRecord.serviceName, dataPerRecord.stubName,
            dataPerRecord.respCode).subscribe((stubs) => {

                this.resetAllDefaultStubsValidation();

                if (stubs && stubs.length) {

                    this.updateDefaultStubStatus(recordName, dataPerRecord, allOccurrence, stubs[0]);
                } else {

                    dataPerRecord.stubName = this.oldValuesForStubs[recordName + dataPerRecord.serviceName].stubName;

                    dataPerRecord.respCode = this.oldValuesForStubs[recordName + dataPerRecord.serviceName].respCode;

                    this.errorOverLay = {
                        message: 'can not find stub with this name and response code, your update will be cancelled',
                        success: false
                    };
                }
            });
    }

    updateDefaultStubStatus(mainRecordName, dataPerRecord, allOccurrence, newStub) {

        let keyWithRecordName;

        let keyWithoutRecordName;

        if (allOccurrence) {

            for (let key in this.defaultStubsStatus) {

                if (key.indexOf(dataPerRecord.serviceName) >= 0) {

                    delete this.defaultStubsStatus[key];
                }
            }

            keyWithoutRecordName = dataPerRecord.serviceName + ' ||| ' + dataPerRecord.stubName + ' ||| ' + dataPerRecord.respCode;

            this.defaultStubsStatus[keyWithoutRecordName] = 'DETECTED';

            this.allRecords.forEach((recordName) => {

                recordName = recordName.toLowerCase();

                const index: number = this.defaultStubsPerRecord[recordName]
                    .findIndex((data) => data.serviceName === dataPerRecord.serviceName);

                this.defaultStubsPerRecord[recordName][index] = {
                    stubName: newStub.stubName,
                    oldStubName: newStub.stubName,
                    respCode: newStub.respCode,
                    serviceName: dataPerRecord.serviceName
                };
            });
        } else {

            keyWithoutRecordName = dataPerRecord.serviceName
                + ' ||| ' + dataPerRecord.oldStubName + ' ||| ' + dataPerRecord.respCode;

            let counter = 0;

            if (this.defaultStubsStatus[keyWithoutRecordName]) {

                this.allRecords.forEach((recordName) => {

                    recordName = recordName.toLowerCase();

                    keyWithRecordName = recordName + ' ||| ' + dataPerRecord.serviceName
                        + ' ||| ' + dataPerRecord.stubName + ' ||| ' + dataPerRecord.respCode;

                    const index: number = this.defaultStubsPerRecord[recordName]
                        .findIndex((data) => data.serviceName === dataPerRecord.serviceName);

                    if (this.defaultStubsStatus[keyWithRecordName] || index < 0) {

                        ++counter;
                    }
                });
            }

            if (counter === this.allRecords.length - 1) {

                for (let key in this.defaultStubsStatus) {

                    if (key.indexOf(dataPerRecord.serviceName) >= 0) {

                        delete this.defaultStubsStatus[key];
                    }
                }

                keyWithoutRecordName = dataPerRecord.serviceName
                    + ' ||| ' + dataPerRecord.stubName + ' ||| ' + dataPerRecord.respCode;

                this.defaultStubsStatus[keyWithoutRecordName] = 'DETECTED';
            } else {

                for (let key in this.defaultStubsStatus) {

                    if (key.indexOf(dataPerRecord.serviceName) >= 0 && key.startsWith(mainRecordName)) {

                        delete this.defaultStubsStatus[key];
                    }
                }

                keyWithRecordName = mainRecordName + ' ||| ' + dataPerRecord.serviceName
                    + ' ||| ' + dataPerRecord.stubName + ' ||| ' + dataPerRecord.respCode;

                this.defaultStubsStatus[keyWithRecordName] = 'DETECTED';
            }

            dataPerRecord.oldStubName = dataPerRecord.stubName;
        }
    }

    getDefaultStubStatus(recordName: string, dataPerRecord) {

        let keyWithRespCode = recordName + ' ||| ' + dataPerRecord.serviceName + ' ||| ' + dataPerRecord.stubName + ' ||| ' + dataPerRecord.respCode;

        let keyWithOutRespCode = dataPerRecord.serviceName + ' ||| ' + dataPerRecord.stubName + ' ||| ' + dataPerRecord.respCode;

        let status: string = null;

        if (this.checkForMixredUserTypes(keyWithRespCode) || this.checkForMixredUserTypes(keyWithOutRespCode)) {

            status = 'DETECTED';
        }

        status = this.defaultStubsStatus[keyWithRespCode] ? this.defaultStubsStatus[keyWithRespCode] : this.defaultStubsStatus[keyWithOutRespCode];

        // this.allStubsAreDetected = !!status && this.allStubsAreDetected && (dataPerRecord.stubName === dataPerRecord.oldStubName);

        this.allStubsAreDetected = !!status && this.allStubsAreDetected;

        return status;
    }

    resetAllDefaultStubsValidation() {

        this.allStubsAreDetected = true;
    }

    allDefaultStubsAreDetected() {

        let isValid = true;

        for (let key in this.defaultStubsStatus) {

            if (!this.checkForMixredUserTypes(key) && this.defaultStubsStatus[key] !== 'DETECTED') {
                isValid = false;
                break;
            }
        }

        return isValid && this.allStubsAreDetected;
    }

    checkForMixredUserTypes(stubName) {

        let isMixedUserStub = false;

        let userTypes;

        if (stubName && stubName.indexOf('.') > 0) {

            const phrases = stubName.split(' ||| ');

            if (phrases.length === 3 || phrases.length === 2) {

                stubName = phrases[1];
            } else if (phrases.length === 1) {

                stubName = phrases[0];
            } else {

                return false;
            }

            const actorsString = stubName.split('.')[1];

            userTypes = actorsString.split('|||');

            userTypes = userTypes.map((userType) => userType.replace(/\d+/g, ''));

            for (var counter = 0; counter < USER_TYPES.length; counter++) {

                if ((!isNaN(Number(actorsString[0])) && userTypes[0] === USER_TYPES[counter]) || actorsString.startsWith(USER_TYPES[counter])) {

                    isMixedUserStub = true;

                    break;
                }
            }
        }

        return isMixedUserStub && intersection(userTypes, USER_TYPES).length === userTypes.length;
    }

    closeOverLay() {

        this.errorOverLay = null;

        if (this.automationService.identifiersPerService) {

            this.router.navigate(['/automation/tdrs-validation']);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/tdrs-creation/tdrs-creation.component.ts